<mat-accordion>
  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 0" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">1</span>
          <span class="title">Add Change Order</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="wrapper">
      <img src="../../../../assets/img/fname_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Job *</span>
        <span class="value">{{changeOrder?.jobName}}</span>
      </div>
    </div>

    <div class="wrapper">
      <img src="../../../../assets/img/fname_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Change Order Type *</span>
        <span class="value">{{changeOrder?.orderType?.name}}</span>
      </div>
    </div>



  </mat-expansion-panel>

  <mat-expansion-panel [expanded]="this.step?.event?.selectedIndex-1 === 1" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title_wrap">
          <span class="number">2</span>
          <span class="title">Drawing</span>
        </div>

      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="wrapper">
      <img src="../../../../assets/img/fname_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label">Drawing Date</span>
        <span class="value">{{drawing?.date | date}}</span>
      </div>
    </div>
    <div class="wrapper">
      <img src="../../../../assets/img/fname_icon.svg" alt="icon" class="icon">
      <div class="wrap">
        <span class="label"> Drawing Type</span>
        <span class="value">{{drawing?.type?.name}}</span>
      </div>
    </div>
      <div class="wrapper">
        <img src="../../../../assets/img/fname_icon.svg" alt="icon" class="icon">
        <div class="wrap">
          <span class="label">No.#</span>
          <span class="value">{{drawing?.number}}</span>
        </div>
     </div>


  </mat-expansion-panel>


</mat-accordion>
